import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMoonDown = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 32,
	height: 24,
	viewBox: "0 0 32 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_2868_9063)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M15.3252 10.4414C15.5595 10.6757 15.9395 10.6757 16.1738 10.4414L19.0908 7.52541C19.3251 7.29112 19.325 6.91108 19.0908 6.67677C18.8565 6.44249 18.4765 6.4425 18.2422 6.67677L16.3545 8.56447V3.59962C16.3543 3.26843 16.0861 3.00001 15.7549 3.00001C15.4236 3.00001 15.1555 3.26843 15.1553 3.59962V8.57619L13.2568 6.67677C13.0226 6.44262 12.6435 6.44263 12.4092 6.67677C12.1749 6.91108 12.1749 7.29109 12.4092 7.52541L15.3252 10.4414Z",
				fill: "#DFCBF5",
				fillOpacity: .8
			}),
			/* @__PURE__ */ _jsx("ellipse", {
				cx: 15.75,
				cy: 24.8671,
				rx: 11.25,
				ry: 11.25,
				fill: "url(#paint0_linear_2868_9063)"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M15.7451 13.6172C21.9589 13.6172 26.9961 18.6536 26.9961 24.8662C26.9961 31.0788 21.9589 36.1152 15.7451 36.1152C13.7344 36.1152 11.8484 35.585 10.2148 34.6611C10.8296 34.7793 11.464 34.8437 12.1133 34.8437C17.6361 34.8437 22.1133 30.3665 22.1133 24.8437C22.1133 19.3209 17.6361 14.8437 12.1133 14.8437C11.5034 14.8437 10.9069 14.9013 10.3271 15.0058C11.9344 14.1211 13.7808 13.6172 15.7451 13.6172Z",
				fill: "url(#paint1_linear_2868_9063)"
			})
		]
	}), /* @__PURE__ */ _jsxs("defs", { children: [
		/* @__PURE__ */ _jsxs("linearGradient", {
			id: "paint0_linear_2868_9063",
			x1: 15.75,
			y1: 14.2549,
			x2: 15.75,
			y2: 36.0653,
			gradientUnits: "userSpaceOnUse",
			children: [/* @__PURE__ */ _jsx("stop", {
				stopColor: "#DFCBF5",
				stopOpacity: .4
			}), /* @__PURE__ */ _jsx("stop", {
				offset: 1,
				stopColor: "#9565FD",
				stopOpacity: .2
			})]
		}),
		/* @__PURE__ */ _jsxs("linearGradient", {
			id: "paint1_linear_2868_9063",
			x1: 10.1269,
			y1: 24.8673,
			x2: 27.0027,
			y2: 24.8673,
			gradientUnits: "userSpaceOnUse",
			children: [/* @__PURE__ */ _jsx("stop", {
				stopColor: "#DFCBF5",
				stopOpacity: .7
			}), /* @__PURE__ */ _jsx("stop", {
				offset: 1,
				stopColor: "#9565FD"
			})]
		}),
		/* @__PURE__ */ _jsx("clipPath", {
			id: "clip0_2868_9063",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 32,
				height: 24,
				fill: "white"
			})
		})
	] })]
});
export default SvgMoonDown;
